import React, { useState, useContext } from 'react';
import Modal from '../../../UI/Modal/Modal'
import css from './TableParams.module.css'
import { AppContext } from '../../../../providers/appProvider';
import GearData from "../../../../assets/Icon/GearData";
import { useTranslation } from 'react-i18next';


const TableParams = ({ columns, setColumns }) => {
    const {t} = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { appState, app } = useContext(AppContext);


    const openTableParams = () => {
        setIsModalOpen(true)
    }

    const closeTableParams = () => {
        setIsModalOpen(false)
    }

    const handleColumnToggle = (columnName) => {
        setColumns({
            ...columns,
            [columnName]: !columns[columnName],
        });
    };

    return (
        <div>
            <span className={css.rowsBtn} onClick={() => openTableParams()} >
            <GearData/>
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => closeTableParams()}>

                <div className={css.modalHead} >
                    <h3>
                    {t('Columns')}
                    </h3>
                </div>
 

                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="toggleID"
                            checked={columns.id}
                            onChange={() => handleColumnToggle('id')}
                        />
                        <label htmlFor="toggleID" >ID</label>
                    </div>
                </div>




                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="toggleVIN"
                            checked={columns.vin}
                            onChange={() => handleColumnToggle('vin')}
                        />
                        <label   htmlFor="toggleVIN" >VIN CODE</label>
                    </div>
                </div>



                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="toggleClient"
                            checked={columns.client}
                            onChange={() => handleColumnToggle('client')}
                        />
                        <label htmlFor="toggleClient" >{t('Client')}</label>
                    </div>
                </div>

 
  


                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="toggleContact"
                            checked={columns.contact}
                            onChange={() => handleColumnToggle('contact')}
                        />
                        <label htmlFor="toggleContact" >{t('Contact')}</label>
                    </div>
                </div>

 


                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="togglePurchased"
                            checked={columns.purchased}
                            onChange={() => handleColumnToggle('purchased')}
                        />
                        <label htmlFor="togglePurchased" >{t('PurchaseDate')}</label>
                    </div>
                </div>


                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="toggleSenderAt"
                            checked={columns.sender_at}
                            onChange={() => handleColumnToggle('sender_at')}
                        />
                        <label htmlFor="toggleSenderAt" >{t('SendAt')}</label>
                    </div>
                </div>


                 <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="toggleRecieverAt"
                            checked={columns.reciever_at}
                            onChange={() => handleColumnToggle('reciever_at')}
                        />
                        <label htmlFor="toggleRecieverAt" >{t('ReceivedAt')}</label>
                    </div>
                </div>
                
                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="togglebl_number"
                            checked={columns.bl_number}
                            onChange={() => handleColumnToggle('bl_number')}
                        />
                        <label htmlFor="togglebl_number" >BL NUMBER</label>
                    </div>
                </div>
 

                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="toggleCar"
                            checked={columns.car}
                            onChange={() => handleColumnToggle('car')}
                        />
                        <label htmlFor="toggleCar" >{t('Car')}</label>
                    </div>
                </div>
 

                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="toggleWebsite"
                            checked={columns.website}
                            onChange={() => handleColumnToggle('website')}
                        />
                        <label htmlFor="toggleWebsite" >{t('WebSite')}</label>
                    </div>
                </div>

                {app.hasPermission("CAR_AGENT_SHOW") && <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }>
                        <input
                            type="checkbox"
                            id="toggleAgentCRM"
                            checked={columns.agentcrm}
                            onChange={() => handleColumnToggle('agentcrm')}
                        />
                        <label htmlFor="toggleAgentCRM" >{t('Agent')}</label>
                    </div>
                </div>}
 

                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="toggleSaler"
                            checked={columns.saler}
                            onChange={() => handleColumnToggle('saler')}
                        />
                        <label htmlFor="toggleSaler" >{t('Saler')}</label>
                    </div>
                </div>

                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="toggleDealer"
                            checked={columns.dealer}
                            onChange={() => handleColumnToggle('dealer')}
                        />
                        <label htmlFor="toggleDealer" >{t('Dealer')}</label>
                    </div>
                </div>

                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="toggleTransit"
                            checked={columns.transit}
                            onChange={() => handleColumnToggle('transit')}
                        />
                        <label htmlFor="toggleTransit" >{t('Transit')}</label>
                    </div>
                </div>
 

                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="toggleContainer"
                            checked={columns.container}
                            onChange={() => handleColumnToggle('container')}
                        />
                        <label htmlFor="toggleContainer" >{t('Container')}</label>
                    </div>
                </div>
 
                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="toggle_export_country"
                            checked={columns.export_country}
                            onChange={() => handleColumnToggle('export_country')}
                        />
                        <label htmlFor="toggle_export_country" >{t('Export')}</label>
                    </div>
                </div>
 
                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="togglesender"
                            checked={columns.sender}
                            onChange={() => handleColumnToggle('sender')}
                        />
                        <label htmlFor="togglesender" >გამომგაზავნი</label>
                    </div>
                </div>
 
                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="togglereciever"
                            checked={columns.reciever}
                            onChange={() => handleColumnToggle('reciever')}
                        />
                        <label htmlFor="togglereciever" >{t('Receiver')}</label>
                    </div>
                </div>
 

                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="toggledealerPrice"
                            checked={columns.dealerPrice}
                            onChange={() => handleColumnToggle('dealerPrice')}
                        />
                        <label htmlFor="toggledealerPrice" >{t('DealerCommission')}</label>
                    </div>
                </div>
 

                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="toggleinsurance"
                            checked={columns.insurance}
                            onChange={() => handleColumnToggle('insurance')}
                        />
                        <label htmlFor="toggleinsurance" >{t('Insurance')}</label>
                    </div>
                </div>

     

                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="togglestatus"
                            checked={columns.status}
                            onChange={() => handleColumnToggle('status')}
                        />
                        <label htmlFor="togglestatus" >{t('Status')}</label>
                    </div>
                </div>

      
                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="togleDocIssuer"
                            checked={columns.doc_issue}
                            onChange={() => handleColumnToggle('doc_issue')}
                        />
                        <label htmlFor="togleDocIssuer" >{t('Recipientofthedocument')}</label>
                    </div>
                </div>
      
                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="togleFinalRecipient"
                            checked={columns.final_recipient}
                            onChange={() => handleColumnToggle('final_recipient')}
                        />
                        <label htmlFor="togleFinalRecipient" >{t('საბოლოო მიმღები')}</label>
                    </div>
                </div>


                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="toglePercent"
                            checked={columns.percent}
                            onChange={() => handleColumnToggle('percent')}
                        />
                        <label htmlFor="toglePercent" >{t('FinalRecipient')}</label>
                    </div>
                </div>

                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="togleClientDiscount"
                            checked={columns.client_discount}
                            onChange={() => handleColumnToggle('client_discount')}
                        />
                        <label htmlFor="togleClientDiscount" >{t('Discount')}</label>
                    </div>
                </div>
  

                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="togleArchive"
                            checked={columns.archive}
                            onChange={() => handleColumnToggle('archive')}
                        />
                        <label htmlFor="togleArchive" >{t('Archive')}</label>
                    </div>
                </div>
  

                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="togleMarineLine"
                            checked={columns.marine_line}
                            onChange={() => handleColumnToggle('marine_line')}
                        />
                        <label htmlFor="togleMarineLine" >{t('MarineLine')}</label>
                    </div>
                </div>
  
  

                <div style={{ width: '100%',  display: 'flex'}}>
                    <div className={ css.formCheck }> 
                        <input
                            type="checkbox"
                            id="togleFeedback"
                            checked={columns.feedback}
                            onChange={() => handleColumnToggle('feedback')}
                        />
                        <label htmlFor="togleFeedback" >{t('Feedback')}</label>
                    </div>
                </div>
  

            </Modal>
        </div>
    );
};

export default TableParams;
